var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata"},[_c('img',{staticClass:"nodataImg",attrs:{"src":require("@/assets/image/zhenyunOrder/noData.png"),"alt":""}}),_c('div',{staticClass:"nodataText"},[_vm._v("暂未找到相关询盘")])])
}]

export { render, staticRenderFns }